import { Node } from "../node";

export class SwitchTreeNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "SwitchTreeNode",

      decisionTreeId: undefined,
      targetNodeId: "continue",
    };
  }

  get startNodeId() {
    return this.decisionTreeId ? `decision-tree-${this.decisionTreeId}-node-start` : "continue";
  }

  get possibleNextNodeIds() {
    return [this.startNodeId];
  }

  autoAdvance() {
    return true;
  }

  nextNodeId() {
    return this.startNodeId;
  }
}
